import { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Card from '../Card/Card';


export default function Cards(props) {
	let navigate = useNavigate();
	const params = useParams();
	const [cat, setCat] = useState(props.cat);
	const [arr, setArr] = useState(props.arr);	
	const [category, setCategory] = useState('');

	function handleClick(e, id) {
		e.preventDefault();

		if(cat === 'cat') {
			navigate(arr[id].category)
			setCat('worlds');
			setArr(arr[id].worlds);
		} 
	}

	
	useEffect(() => {
		if(params.category) {
			props.arr.map(item => {	
				if(item.category === params.category) {
					setCat('worlds');
					setArr(props.arr[item.id].worlds);
					setCategory(props.arr[item.id].trans);
				} 
			})	
		} else {
			setCat(props.cat);
			setArr(props.arr);
		}
	}, [params.category, props.arr, arr, props.cat]);


	return (
		<>
			{cat === 'worlds' ? <h2 className='text-2xl uppercase mb-5 text-cyan-700'>{category}</h2> : false}
			<div className="flex justify-center flex-wrap gap-6 mb-8">
			{/* <h1>{params.category ? params.category : 'Все категории'}</h1> */}
			{arr.map((item, i) =>
				<Card key={i} id={item.id} item={item} sound={item.sound} myClick={(e)=> handleClick(e, item.id)} view={cat}/>
			)} 
			</div>
		</>
		
	);
}